const isEnvProd = process.env.REACT_APP_IS_PROD === '1';

export const myWayStudioServicesBaseUrl = isEnvProd
    ? 'https://mywayStudioService.y-it.co.il/MyWayStudioServices'
    : 'https://mywayStudioServiceDev.y-it.co.il/MyWayStudioServices';